var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tooltip",
    {
      class: _vm.classNames,
      attrs: { text: _vm.description, tag: "div", enabled: !!_vm.description },
    },
    [
      _c("base-icon", {
        class: _vm.classNames,
        attrs: {
          name: _vm.iconName,
          size: "3x",
          "icon-namespace": _vm.iconNamespace,
        },
      }),
      _vm._v(" "),
      _c(
        "base-title",
        { staticClass: "_mt-3", attrs: { as: "h5", level: "h3" } },
        [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.caption
        ? _c(
            "base-text",
            {
              staticClass: "_tc--light-gray _mt-1",
              attrs: { level: "caption" },
            },
            [_vm._v("\n        " + _vm._s(_vm.caption) + "\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }